import { render } from "./LoginFooter.vue?vue&type=template&id=f9304c66&scoped=true"
import script from "./LoginFooter.vue?vue&type=script&lang=js"
export * from "./LoginFooter.vue?vue&type=script&lang=js"

import "./LoginFooter.vue?vue&type=style&index=0&id=f9304c66&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9304c66"]])

export default __exports__